import React from "react";
import TopBar from "../TopBar/TopBar";
import ReactMarkdown from 'react-markdown';
import "./TermsOfService.scss";

const TermsOfService: React.FC = () => {
  const markdownContent = `## **TERMS OF SERVICE FOR KICKTHETIRES.AI**

**Effective Date:** December 30, 2025

### **1. Acceptance & Eligibility**

By accessing or using the KickTheTires.ai platform (the "Service"), you agree to these Terms and the Pacer.co Privacy Policy.

* **Age Requirement:** You must be at least 18 years of age to use this Service.  
* **Business Authority:** If you are using this Service on behalf of a dealership or business entity, you represent that you have the authority to bind that entity to these Terms.

### **2. Nature of the AI Service ("The Bullsh*t Detector")**

* **Diagnostic Analysis:** KickTheTires.ai provides an AI-powered diagnostic platform to identify potential issues, reconditioning costs, and market anomalies in used car listings.  
* **No Warranty of Accuracy:** Our "Pre-Purchase Inspection (PPI) Reports" are generated using pattern recognition and photo forensics. These are estimates only and are not a substitute for a physical mechanical inspection.  
* **No Liability for Purchases:** Pacer.co is not responsible for any undisclosed vehicle defects or financial losses resulting from a vehicle purchase or trade-in.

### **3. Data Ownership & Usage Rights**

* **Proprietary Interest:** Pacer.co retains all rights, titles, and interests in the Service, including the generated "Scout" reports, "Heat Scores," and any forensic analysis performed on uploaded data.  
* **License to Use Uploads:** By uploading photos or listing URLs, you grant Pacer.co a perpetual, irrevocable, and royalty-free license to use, analyze, and store that data to provide the Service and improve our AI models.  
* **Data Privacy:** While Pacer.co owns the analytical output, we securely process your documents and delete the specific raw files after your report has been generated to protect your privacy.

### **4. Lead Generation & "Pushing" Info to Dealers**

The Service includes features designed to connect vehicle owners with dealerships for sales, trade-ins, or financing.

* **Consent to Transfer:** By using the "Trade-in" or "Analyze a Listing" features, you expressly authorize Pacer.co to "push" and share your **Owner Information** (name, contact details) and **Vehicle Information** (VIN, condition report, AI analysis) to third-party dealerships.  
* **Dealer as Independent Controller:** Once transferred, the dealership becomes an independent controller of that data. Pacer.co is not responsible for the dealer's subsequent use of your information or their privacy practices.  
* **No Endorsement:** The transfer of information to a dealer does not constitute an endorsement of that dealer by Pacer.co.

### **5. Payments & Commercial Tiers**

* **No Refunds:** All fees for AI reports are billed on a per-use or credit basis and are non-refundable once the report is generated.  
* **Commercial Restrictions:** Use of the Service for high-volume commercial purposes (e.g., by professional car flippers or large dealer groups) requires a specific commercial license tier.

### **6. Dispute Resolution (Mandatory Arbitration)**

Any dispute arising from these Terms shall be resolved through **binding individual arbitration** in the **State of Delaware**.

* **Class Action Waiver:** You agree to bring claims only in your individual capacity and not as a plaintiff or class member in any class or representative proceeding.  
* **Governing Law:** These Terms are governed by the laws of Delaware.`;
  return (
    <div className="terms-of-service-page">
      <TopBar title="Terms of Service" />
      <div className="terms-of-service-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    </div>
  );
};

export default TermsOfService;
